import { apiClient } from './api';
import { AdminUserListResponse, UserRole, UserStatus } from '../types/adminUser';

const BASE = '/api/v1/admin/users';

/** Encodes a Dex subject for use as a single URL path segment. */
const segment = (subject: string): string => encodeURIComponent(subject);

/**
 * Admin-only user management (issue #379). Every route requires the caller's
 * Dex subject to hold the `admin` role; the id_token is attached by the
 * ApiClient request interceptor. A non-admin caller gets 403 from all of them.
 */
export const adminUserService = {
  /** List one page of accounts, newest login information included. */
  async list(limit = 50, offset = 0): Promise<AdminUserListResponse> {
    return apiClient.get<AdminUserListResponse>(
      `${BASE}?limit=${limit}&offset=${offset}`
    );
  },

  /** Grant a role. Granting a role the user already holds is a no-op. */
  async assignRole(subject: string, role: UserRole): Promise<void> {
    await apiClient.post<null>(`${BASE}/${segment(subject)}/roles`, { role });
  },

  /** Revoke a role. Fails with 404 when the user does not hold it. */
  async revokeRole(subject: string, role: UserRole): Promise<void> {
    await apiClient.delete<null>(`${BASE}/${segment(subject)}/roles/${role}`);
  },

  /** Deactivate or reactivate an account. */
  async setStatus(subject: string, status: UserStatus): Promise<void> {
    await apiClient.put<null>(`${BASE}/${segment(subject)}/status`, { status });
  },
};
